import { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';

export const useAppSettings = () => {
  const [appSettings, setAppSettings] = useState({
    schoolSession: null,
    schoolTerm: null,
    schoolName: null,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const settingsRef = ref(database, 'appSettings');

    const unsubscribe = onValue(
      settingsRef,
      (snapshot) => {
        const data = snapshot.val();
        setAppSettings({
          schoolSession: data?.currentSession?.session || null,
          schoolTerm: data?.currentSession?.term || null,
          schoolName: data?.schoolName || null,
        });
        setLoading(false);
      },
      (err) => {
        console.error("Firebase settings read failed: ", err);
        setError("Failed to load app settings.");
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return { appSettings, loading, error };
};
